import { render, staticRenderFns } from "./ThinScrollChip.vue?vue&type=template&id=700e8d5f&scoped=true"
import script from "./ThinScrollChip.vue?vue&type=script&lang=js"
export * from "./ThinScrollChip.vue?vue&type=script&lang=js"
import style0 from "./ThinScrollChip.vue?vue&type=style&index=0&id=700e8d5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e8d5f",
  null
  
)

export default component.exports